// extracted by mini-css-extract-plugin
module.exports = {"billing":"billing-module--billing--3DwTO","billing__text":"billing-module--billing__text--2z7jf h5","billing__btns":"billing-module--billing__btns--yfTUU"};